import { isNumber } from 'lodash-es';

import { Timecode } from '@iconik-io/core/src/timecode';

import { zeroTimecode } from './constants/timecode';
import type { TimecodeOptions } from './get_proxy_timecode_options';

type Parameters = {
  startMilliseconds: number | null | undefined;
  endMilliseconds: number | null | undefined;
  timecodeOptions: TimecodeOptions;
};

function toHms(timecode: Timecode) {
  const { seconds, minutes, hours } = timecode.toParts();
  return `${hours}:${minutes}:${seconds}`;
}

export function rangeToHmsString({
  startMilliseconds,
  endMilliseconds,
  timecodeOptions,
}: Parameters) {
  if (!isNumber(startMilliseconds) || !isNumber(endMilliseconds)) {
    return undefined;
  }

  const startTimecodeObject = new Timecode(timecodeOptions, {
    smpte: timecodeOptions.startTimecode ?? zeroTimecode,
  });
  const startTimecodeSeconds = startTimecodeObject.toSeconds();

  const startTime = toHms(
    new Timecode(timecodeOptions, {
      seconds: startTimecodeSeconds + startMilliseconds / 1000,
    }),
  );

  const endTime = toHms(
    new Timecode(timecodeOptions, {
      seconds: startTimecodeSeconds + endMilliseconds / 1000,
    }),
  );

  return `${startTime} -> ${endTime}`;
}
